import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
const currentDateFilter = {
  field: 'closeDate',
  value: `${dayjs().utc().startOf('day').format().replace('Z', '')}`,
  operator: 'DATE_GTE',
};
export default currentDateFilter;
